import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserPayment`;;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null) {
      if (key == "portalList" && value.length > 0) {
        let portalListSTR = "";
        value.forEach(item => {
          portalListSTR += "portalList=" + item.value + "&"
        });
        stringparams = stringparams + portalListSTR;
        //stringparams = stringparams + value;
      }
      else {
        stringparams = stringparams + key + "=" + value + "&";
      }
    }
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiUserPayment = {
  getAllUserPayment: (params) => {
    const url = `${baseServiceUrl}/getAllUserPayment`;
    return ServiceApi.get(url, { params });
  },
  getUserPaymentById: (params) => {
    const url = `${baseServiceUrl}/getUserPaymentById?id=` + params;
    return ServiceApi.get(url, params);
  },
  getAllUserPaymentToExcel: (params) => {
    const url = `${baseServiceUrl}/getAllUserPaymentToExcel`;
    return  ServiceApi.get(url,  {params : params , responseType : 'blob'} );
  },
};

export default ApiUserPayment;
